import React from 'react';
import { company, regulatory } from '../../models/content';

export default function V2RegulatoryPage() {
  return (
    <main>
      <section className="page-hero">
        <div className="wrap">
          <span className="v2-badge">
            <span className="dot" />
            {regulatory.heroBadge}
          </span>
          <h1>
            {regulatory.heroTitle.map((part, index) =>
              typeof part === 'string' ? (
                <React.Fragment key={index}>{part}</React.Fragment>
              ) : (
                <span key={index} className="it">
                  {part.it}
                </span>
              )
            )}
          </h1>
        </div>
      </section>

      <section>
        <div className="wrap regulatory-content">
          <div className="legal-table-scroll legal-table-scroll--regulatory">
            <table>
              <thead>
                <tr>
                  {regulatory.tableHeaders.map((header) => (
                    <th key={header} scope="col">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {regulatory.funds.map((fund) => (
                  <tr key={fund.registrationNo}>
                    <td>{fund.name}</td>
                    <td>{fund.category}</td>
                    <td>{fund.registrationNo}</td>
                    <td>{fund.manager}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="prose">
            <h2>{regulatory.investorHeading}</h2>
            <p>
              Please email the following persons for any queries:
              <br />
              <a href={company.emailHref}>
                <strong>{regulatory.supportEmailDisplay}</strong>
              </a>
            </p>
            <p>
              If you have any dispute that is unresolved, you can also use the Smart ODR portal in the link below:
              <br />
              <strong>
                &quot;ODR Portal link-{' '}
                <a href={regulatory.odrUrl} target="_blank" rel="noopener noreferrer">
                  {regulatory.odrUrl}
                </a>
                &quot;
              </strong>
            </p>
            <p>*works best on Google Chrome browser</p>
          </div>
        </div>
      </section>
    </main>
  );
}
